import React, { useEffect, useState } from "react";
import Button from "../global/Button";
import { useGetDictionary } from "../../hooks/useGetDictionary";
import { Controller, useForm } from "react-hook-form";
import Controll from "../academy/Controll";
import Input from "../global/Input";
import RadioInput from "../global/RadioInput";
import ValidateError from "../global/ValidateError";
import DateInput from "../global/DateInput";
import { getFormatedDate, toastMessage } from "../../utils/utils";
import MultiSearchableSelect from "../global/MultiSearchableSelect";
import {
  useAddUserToWalletMutation,
  useCreateWalletMutation,
  useGetAllWalletQuery,
  useGetAllWalletServicesQuery,
} from "../../lib/redux/services/sections/Customers";
import { CURRENCY } from "../../constants";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import SelectPlayerBox from "../booking/SelectPlayerBox";
import { useGetPlayersForBookingQuery } from "../../lib/redux/services/sections/Booking";
import { useGetAllPaymentMethodsQuery } from "../../lib/redux/services/sections/Payments";
import { useParams } from "react-router-dom";
import ModalButton from "../global/ModalButton";
import QRModal from "../booking/QRModal";
import useClipBoard from "../../hooks/useClipBoard";
import { changeViewMode } from "../../lib/redux/slices/controlSlice";
type props = {
  type: "new" | "edit" | "duplicate" | "view";
  rowId?: number;
  removeAnimation?: () => void;
};
type FormType = {
  player_id: string;
  payment_method_id: any;
};
function UsersForm({ type, rowId, removeAnimation }: props) {
  const { shared, inputs } = useGetDictionary();
  const dispatch = useDispatch();
  const [link, setLink] = useState("");
  const { id } = useParams();
  const club_id = useSelector((state: any) => state.user.selectedClub);
  const [addUser] = useAddUserToWalletMutation();
  const { copyText } = useClipBoard();
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
    setValue,
    trigger,
    watch,
    getValues,
  } = useForm<FormType>({
    defaultValues: {},
  });
  const handleOption = (options: any) => {
    return options.filter(
      (option: any) =>
        !option.is_voucher && !option.is_app && !option.is_multiple
    );
  };
  const onSubmit = async (data: any) => {
    try {
      const response = await toast.promise(
        addUser({
          data,
          club_id,
          wallet_id: id,
        })
          .unwrap()
          .then((res) => {
            if (!res?.data?.link) {
              removeAnimation?.();
            } else {
              setLink(res?.data?.link);
              copyText(res?.data?.link || "", () => {
                toast.success("payment link copied successfully");
              });
            }
          }),
        toastMessage()
      );
      //@ts-ignore
    } catch (error) {
      removeAnimation?.();
    }
  };

  return (
    <div className="w-full px-6 py-8 flex flex-col gap-4 dark:bg-primary h-[90%]">
      <h3 className="font-bold text-lg text-primary dark:text-white  pb-5"></h3>
      <form
        className="w-full h-full flex flex-col justify-between text-primary"
        onSubmit={handleSubmit(onSubmit)}
      >
        <div className="flex w-full gap-8 flex-col ">
          <div className="w-full flex-1">
            <label className="block text-sm mb-2">
              Player name <span className="text-red-500">*</span>
            </label>
            <Controller
              control={control}
              name="player_id"
              rules={{ required: true }}
              render={({ field }) => (
                <>
                  <SelectPlayerBox<any, any>
                    field={field}
                    isCustomOption={true}
                    setValue={setValue}
                    extraParams={{}}
                    requestFn={useGetPlayersForBookingQuery}
                    name={`player_name`}
                    onChange={(selected: {
                      id: number;
                      name: string;
                      price: number;
                    }) => {
                      // @ts-ignore only
                      return field.onChange(selected ? selected.id : null);
                    }}
                  />
                </>
              )}
            />
          </div>
          <div className="w-full flex-1 min-w-[250px]">
            <label className="block text-sm mb-2">
              Payment method <span className="text-red-500">*</span>
            </label>
            <Controller
              control={control}
              name="payment_method_id"
              rules={{ required: true }}
              render={({ field }) => (
                <>
                  <MultiSearchableSelect
                    fetchFunction={useGetAllPaymentMethodsQuery}
                    field={field}
                    valueKey="id"
                    pathParams={{
                      id: club_id,
                      enabled: true,
                    }}
                    handleOption={handleOption}
                    isMulti={false}
                  />
                </>
              )}
            />
          </div>
          {link && (
            <div
              onClick={() => {
                copyText(link || "", () => {
                  toast.success("payment link copied successfully");
                });
              }}
              className="w-full flex-1 min-w-[250px] bg-[#f3f3f3] flex justify-center items-center p-2 rounded-md font-bold"
            >
              <ModalButton
                portal={true}
                buttonContent={"Copy link"}
                modalContent={
                  <QRModal
                    link={link}
                    title={
                      " The link already copied to your clipboard or to can scan the QR code"
                    }
                  />
                }
              />
            </div>
          )}
        </div>

        <div className="flex gap-16 justify-end items-center w-[70%] ml-auto mr-0 mobile:gap-8">
          <Button
            customeStyle="text-red-500 mobile:w-[120px]"
            text={shared.cancel}
            type="submit"
            width="150px"
            onClick={(e) => {
              e.preventDefault();
              removeAnimation?.();
            }}
          />

          <Button
            customeStyle="bg-primary text-white dark:bg-primaryYellow dark:text-primary p-3 px-2 rounded-full w-[200px] mobile:w-[120px]"
            text={shared.save}
            type="submit"
            width="150px"
          />
        </div>
      </form>
    </div>
  );
}

export default UsersForm;
